import { DOCUMENT } from "@angular/common";
import { Inject, Injectable } from "@angular/core";
import { interval, Subject, Observable, combineLatest, asapScheduler, EMPTY } from "rxjs";
import { filter, startWith, switchMap } from "rxjs/operators";
import { ExamModeRestrictionsService } from "./exam-mode-restrictions.service";

@Injectable({
    providedIn: 'root'
})
export class BrowserFocusChecker {
    private TIMER_INTERVAL: number = 1000;
    private DO_NOT_CHECK_TIME: number = 2000;
    private pauseCheckingFocus$: Subject<void> = new Subject();

    private delay$: Observable<boolean> = new Observable((subscriber) => {
        subscriber.next(true);
        setTimeout(() => {
            subscriber.next(false);
            subscriber.complete();
        }, this.DO_NOT_CHECK_TIME);
    });

    private checkingFocusDelay$ = this.pauseCheckingFocus$.pipe(
        startWith(false),
        switchMap(() => this.delay$)
      );

    private checkingInterval$: Observable<number> = interval(this.TIMER_INTERVAL, asapScheduler)
    private checkingFocusDocument$ = combineLatest(this.checkingInterval$, this.checkingFocusDelay$).pipe(
        filter(([_, notCheck]) => !notCheck)
    );

    constructor(
        @Inject(DOCUMENT) private readonly injectedDocument,
        private readonly examService: ExamModeRestrictionsService,
    ) {

        this.examService.isExamInProgress$.pipe(
            switchMap(inProgress => inProgress ?
                this.checkingFocusDocument$ : EMPTY
            )
        ).subscribe(() => this.checkDocumentFocus());

        this.checkingFocusDocument$.subscribe(() => this.checkDocumentFocus());
    }

    public pauseCheckingDocumentFocus() {
        this.pauseCheckingFocus$.next();
    }

    private checkDocumentFocus() {
        if (this.injectedDocument.hasFocus())
            return;

        this.examService.handleBlurEvent();
    }
}